import { render, staticRenderFns } from "./selectroom.vue?vue&type=template&id=2ee94254&"
import script from "./selectroom.vue?vue&type=script&lang=js&"
export * from "./selectroom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports